import { useNavigate } from "react-router-dom";
import { Alert, Button, Col, Nav, Row, Spinner, Tab } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiCodeBraces, mdiCardRemoveOutline } from "@mdi/js";
import { useInfiniteQuery } from "react-query";

import { PageSize, SkeletonCount } from "../../config/defines";
import { getVariaveisListar, getGetVariaveisListarQueryKey } from "../../config/swagger";

import InfiniteScroll from "../../components/InfiniteScroll";
import VariaveisCard from "../../components/VariaveisCard";
import Layout from "../../components/Layout";
import { useState } from "react";

export default function Variaveis() {
	const navigate = useNavigate();

	const [tab, setTab] = useState("empresa");

	const queryEmpresa = useInfiniteQuery(getGetVariaveisListarQueryKey({ offset: 0, limit: PageSize }), ({ pageParam = 0 }) => getVariaveisListar({ offset: pageParam * PageSize, limit: PageSize }), {
		getNextPageParam: (lastPage, allPages) => (lastPage.Data?.length === PageSize ? allPages.length : null),
	});

	const querySistema = useInfiniteQuery(
		getGetVariaveisListarQueryKey({ offset: 0, limit: PageSize, onlySystem: true }),
		({ pageParam = 0 }) => getVariaveisListar({ offset: pageParam * PageSize, limit: PageSize, onlySystem: true }),
		{
			getNextPageParam: (lastPage, allPages) => (lastPage.Data?.length === PageSize ? allPages.length : null),
		}
	);

	return (
		<Layout>
			<h5 className="mt-4 mb-4 d-flex align-items-center fw-light">
				<Icon path={mdiCodeBraces} size={1} className="me-2" /> Variáveis
				{queryEmpresa.isRefetching && <Spinner size="sm" className="ms-1" variant="secondary" />}
				<div className="float-right ms-auto" style={{ marginTop: -10, marginBottom: -10 }}>
					<Button
						variant="primary"
						className="rounded-3 shadow-sm"
						onClick={() => {
							navigate("/variavelFormulario");
						}}
					>
						Cadastrar
					</Button>
				</div>
			</h5>

			<Tab.Container
				activeKey={tab}
				onSelect={(key) => {
					if (key) setTab(key);
				}}
			>
				<Nav variant="tabs" className="mb-2">
					<Nav.Item>
						<Nav.Link eventKey="empresa">Empresa</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link eventKey="sistema">Sistema</Nav.Link>
					</Nav.Item>
				</Nav>
				<Tab.Content className="mb-4">
					<Tab.Pane eventKey="empresa">
						<Row className="mb-4">
							{queryEmpresa.isLoading &&
								Array.from({ length: Number(SkeletonCount) }, (_, index) => {
									return (
										<Col md={12} key={index}>
											<VariaveisCard skeleton />
										</Col>
									);
								})}
							{!queryEmpresa.isLoading && queryEmpresa.isError && (
								<Col md={12}>
									<Alert variant="secondary" className="text-center">
										Problema na operação. Tente novamente mais tarde
									</Alert>
								</Col>
							)}
							{!queryEmpresa.isLoading && queryEmpresa.data?.pages[0].Data && queryEmpresa.data.pages[0].Data.length === 0 && (
								<Col md={12}>
									<Alert variant="light" className="text-center p-4 d-flex justify-content-center align-items-center">
										<Icon path={mdiCardRemoveOutline} size={1} className="me-2" />
										Nenhum registro encontrado
									</Alert>
								</Col>
							)}
							{!queryEmpresa.isLoading &&
								queryEmpresa.data?.pages.map((dataPage, dataPageIndex) => {
									return (
										dataPage?.Data &&
										dataPage?.Data.length >= 1 &&
										dataPage?.Data.map((item) => {
											return (
												<Col md={12} key={item.id}>
													<VariaveisCard data={item} />
												</Col>
											);
										})
									);
								})}
							<Col md={12} className="text-center">
								<InfiniteScroll
									more={queryEmpresa.hasNextPage}
									loading={queryEmpresa.isFetchingNextPage}
									loader={<VariaveisCard skeleton />}
									load={() => {
										queryEmpresa.fetchNextPage();
									}}
								/>
							</Col>
						</Row>
					</Tab.Pane>
					<Tab.Pane eventKey="sistema">
						<Row className="mb-3">
							{querySistema.isLoading &&
								Array.from({ length: Number(SkeletonCount) }, (_, index) => {
									return (
										<Col md={12} key={index}>
											<VariaveisCard skeleton />
										</Col>
									);
								})}
							{!querySistema.isLoading && querySistema.isError && (
								<Col md={12}>
									<Alert variant="secondary" className="text-center">
										Problema na operação. Tente novamente mais tarde
									</Alert>
								</Col>
							)}
							{!querySistema.isLoading && querySistema.data?.pages[0].Data && querySistema.data.pages[0].Data.length === 0 && (
								<Col md={12}>
									<Alert variant="light" className="text-center p-4 d-flex justify-content-center align-items-center">
										<Icon path={mdiCardRemoveOutline} size={1} className="me-2" />
										Nenhum registro encontrado
									</Alert>
								</Col>
							)}
							{!querySistema.isLoading &&
								querySistema.data?.pages.map((dataPage, dataPageIndex) => {
									return (
										dataPage?.Data &&
										dataPage?.Data.length >= 1 &&
										dataPage?.Data.map((item, index) => {
											return (
												<Col md={12} key={index}>
													<VariaveisCard data={item} />
												</Col>
											);
										})
									);
								})}
							<Col md={12} className="text-center">
								<InfiniteScroll
									more={querySistema.hasNextPage}
									loading={querySistema.isFetchingNextPage}
									loader={<VariaveisCard skeleton />}
									load={() => {
										querySistema.fetchNextPage();
									}}
								/>
							</Col>
						</Row>
						<Alert variant="light" className="mb-4 fw-light">
							<strong>Variáveis do sistema</strong> são substituídas por valores dinâmicos durante a execução.
							<hr className="my-2" />
							<div className="mb-2">
								<code>%DATE%</code> — Retorna a data atual.
								<ul className="mb-1 mt-1">
									<li>
										<strong>Operador:</strong> Adicione ou subtraia dias. Ex: <code>%DATE+86400%</code> (1 dia no futuro), <code>%DATE-86400%</code> (1 dia atrás)
									</li>
									<li>
										<strong>Formatação:</strong> Defina o formato de saída. Ex: <code>%DATE:YYYY-MM-DD%</code>, <code>%DATE:DD/MM/YYYY%</code>
									</li>
									<li>
										<strong>Combinado:</strong> Use operador e formato juntos. Ex: <code>%DATE+86400:YYYY-MM-DD%</code>
									</li>
								</ul>
							</div>
							<div className="mb-2">
								<code>%TIMESTAMP%</code> — Retorna o timestamp Unix atual (em segundos).
								<ul className="mb-1 mt-1">
									<li>
										<strong>Operador:</strong> Adicione ou subtraia segundos. Ex: <code>%TIMESTAMP+3600%</code> (1 hora no futuro), <code>%TIMESTAMP-3600%</code> (1 hora atrás)
									</li>
								</ul>
							</div>
							<div>
								<code>%UUID%</code> — Gera um identificador único (UUID) a cada execução.
							</div>
						</Alert>
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</Layout>
	);
}
